import { stringify } from 'qs'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import { getFlag } from 'helpers/featureFlags/provider'
import config from 'config'
import routeTypes from './enums/routeTypes'
import viewTypes from './enums/viewTypes'

export function makeLibraryURL(params, folderUID) {
	let path = routeTypes.LIBRARY
	if (folderUID && folderUID !== '0' && !params.query) {
		path += folderUID
	}
	const newParamsObject = {
		q: params.query ? params.query : undefined,
		or: params.orderField,
		...params.lti,
	}
	const queryString = stringify(newParamsObject, { addQueryPrefix: true })
	return path + queryString
}

// Angular route - pending to migrate
export function getUpgradeRoute() {
	return getAngularEnviromentPrefix() + routeTypes.UPGRADE
}

// Angular route - pending to migrate
export function getAuthorRoute(author) {
	return getAngularEnviromentPrefix() + author
}

// Angular route - pending to migrate
export function getCheckoutRoute() {
	return getAngularEnviromentPrefix() + routeTypes.CHECKOUT
}

export function getLandingRoute() {
	return getReactEnviromentPrefix() + routeTypes.MARKET
}

export function getLandingFullRoute() {
	return config.www + getLandingRoute()
}

export function getSearchRoute(searchUrl, queryUrl) {
	searchUrl = searchUrl || 'search'
	return '/' + getReactEnviromentPrefix() + searchUrl + queryUrl
}

export function getLockedContentRoute() {
	return `/${getReactEnviromentPrefix()}${routeTypes.LOCKED_CONTENT}`
}

export function getInteractiveVideoCreateRoute(uid, params, currentView = viewTypes.INTERACTIVE_VIDEO_CREATE) {
	//When interactive-video/select is deleted we should delete the default for currentView
	const baseRoute = getInteractiveVideoCreateRouteBase(uid, currentView)
	return `${baseRoute}${stringify(params, { addQueryPrefix: true })}`
}

export function getInteractiveVideoCreateRouteBase(uid, currentView = viewTypes.INTERACTIVE_VIDEO_CREATE) {
	//When interactive-video/select is deleted we should delete the default for currentView
	const baseRoute = {
		[viewTypes.INTERACTIVE_VIDEO_CREATE]: 'interactive-video/create',
		[viewTypes.INTERACTIVE_VIDEO_CREATION_OEQ]: 'interactive-video/create',
		[viewTypes.INTERACTIVE_VIDEO_CREATION_MCQ]: 'interactive-video/create',
		[viewTypes.VIDEO_CREATE]: 'video/create',
		[viewTypes.VIDEO_CREATION_OEQ]: 'video/create',
		[viewTypes.VIDEO_CREATION_MCQ]: 'video/create',
		[viewTypes.VIDEO_STANDALONE_CREATE]: 'standalone/video/create',
		[viewTypes.VIDEO_STANDALONE_CREATION_OEQ]: 'standalone/video/create',
		[viewTypes.VIDEO_STANDALONE_CREATION_MCQ]: 'standalone/video/create',
	}

	return `/${baseRoute[currentView]}/${uid}`
}

export function addParamToUrl(url, paramKeyToAdd, paramValueToAdd) {
	const urlConnector = url.includes('?') ? '&' : '?'
	return `${url}${urlConnector}${paramKeyToAdd}=${encodeURIComponent(paramValueToAdd)}`
}

export function getAngularEnviromentPrefix() {
	let environment = 'u/'
	if (!getFlag(featureFlagsTypes.STORE_NEW_ROUTES)) {
		environment = 's/'
	}
	return config.www + environment
}

function getReactEnviromentPrefix() {
	let environment = 's/'
	if (!getFlag(featureFlagsTypes.STORE_NEW_ROUTES)) {
		environment = 't/'
	}
	return environment
}

export function getVideoPickerByRoute(currentView, picker, uid, params) {
	const basePaths = {
		[viewTypes.INTERACTIVE_VIDEO_CREATE]: getInteractiveVideoCreatePickerPath,
		[viewTypes.VIDEO_CREATE]: getVideoCreatePickerPath,
		[viewTypes.VIDEO_STANDALONE_CREATE]: getVideoStandaloneCreatePickerPath,
	}
	return basePaths[currentView](picker, uid, params)
}

function getVideoCreatePickerPath(picker, uid, params) {
	const url = `/video/create/${uid}/picker/${picker}`
	const queryString = stringify(params, { addQueryPrefix: true })
	return url + queryString
}

function getVideoStandaloneCreatePickerPath(picker, uid, params) {
	const url = `/standalone/video/create/${uid}/picker/${picker}`
	const queryString = stringify(params, { addQueryPrefix: true })
	return url + queryString
}

function getInteractiveVideoCreatePickerPath(picker, uid, params) {
	const url = `/interactive-video/create/${uid}/picker/${picker}`
	const queryString = stringify(params, { addQueryPrefix: true })
	return url + queryString
}

export function getVideoEditByRoute(currentView, uid, params) {
	const basePaths = {
		[viewTypes.INTERACTIVE_VIDEO_CREATE]: getInteractiveVideoEditPath,
		[viewTypes.VIDEO_CREATE]: getVideoEditPath,
		[viewTypes.VIDEO_STANDALONE_CREATE]: getVideoStandaloneEditPath,
	}
	return basePaths[currentView](uid, params)
}

function getVideoEditPath(uid, params) {
	const url = `/video/create/${uid}/edit`
	const queryString = stringify(params, { addQueryPrefix: true })
	return url + queryString
}

function getInteractiveVideoEditPath(uid, params) {
	const url = `/interactive-video/create/${uid}/edit`
	const queryString = stringify(params, { addQueryPrefix: true })
	return url + queryString
}

function getVideoStandaloneEditPath(uid, params) {
	const url = `/standalone/video/create/${uid}/edit`
	const queryString = stringify(params, { addQueryPrefix: true })
	return url + queryString
}
